'use client'

import DiscoverySearchForm from './discovery-search-form'

export default function SearchHeader({
  linkPrefix = 'sim-racing-events',
  ...props
}) {
  return (
    <DiscoverySearchForm
      {...props}
      mode={linkPrefix.includes('liveries') ? 'liveries' : 'events'}
      action={`/${linkPrefix}`}
    />
  )
}
